<!-- <button matIconButton type="button" class="close" mat-dialog-close><mat-icon>close</mat-icon></button> -->
 <!-- titles in component  -->
  
<!-- <h4 mat-dialog-title>{{ "trace.view-route.title" | translate }}</h4>
<div class="legend-header flex-container container-space-between column">    
    <div class="list-sub-header">{{
        traceView.isActive() &&
        traceView.ref_traceRouteData().metadata.name
        ? traceView.ref_traceRouteData().metadata.name.length > 100
        ? (traceView.ref_traceRouteData().metadata.name | slice: 0:100) +
        '...' 
        : traceView.ref_traceRouteData().metadata.name
        : ('trace.view-route.routewithnoname' | translate)
        }}</div>
   
</div> -->
<!-- legend-body legend-wrapper -->
<div #bottomPaneContent class="bottom-pane-content mat-typography">
    <div class="column ">
        <!-- todo class legend-container -->
        <!-- <ng-template #traceDialogContainer class="legend-container"></ng-template> -->
        <!-- class tab-viewport is used by HostListener touchstart -->
        <div class="tab-viewport">
            <tt-trace-view #traceView [hideTraceCreate]="hideTraceCreate ? 'true' : 'false' "></tt-trace-view>
        </div>
    </div>
</div>
<!-- <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="close-tip">{{'general.close'|translate}}</button>
</mat-dialog-actions> -->